module.exports = __webpack_public_path__ + "static/media/emptyState.c2b877c4.png";